import { SeoLandingLayout, SeoLandingPageData } from '../../../components/SeoLandingLayout';

const data: SeoLandingPageData = {
  seo: {
    title: 'Trésorerie association loi 1901 : obligations et bonnes pratiques | Trezoone',
    description: 'Gérer la trésorerie d\'une association loi 1901 : rôle du trésorier, obligations légales, outils de suivi et bonnes pratiques pour un pilotage serein.',
    canonical: '/tresorerie-association-loi-1901',
    keywords: 'trésorerie association loi 1901, trésorier association, gestion financière association, obligations trésorerie association',
  },
  hero: {
    tag: 'Trésorerie association loi 1901',
    title: 'Trésorier d\'association : un rôle clé, souvent sous-estimé.',
    subtitle: 'La trésorerie d\'une association loi 1901 ne s\'improvise pas. Voici les obligations, les responsabilités et les outils pour assurer ce rôle sereinement.',
    ctaLabel: 'Simplifier ma gestion',
  },
  pilierLink: { label: 'Gestion trésorerie association', href: '/gestion-tresorerie-association' },
  sections: [
    {
      type: 'explain',
      title: 'Rôle et responsabilités du trésorier d\'association',
      content: 'Le trésorier est un poste clé dans le bureau d\'une association. Ses missions :',
      items: [
        'Gérer les comptes bancaires et les caisses de l\'association',
        'Établir et suivre le budget prévisionnel',
        'Produire les états financiers pour l\'assemblée générale',
        'Contrôler les dépenses et valider les paiements',
        'Gérer les relations avec la banque et les financeurs',
        'Préparer les documents pour le commissaire aux comptes (si applicable)',
      ],
    },
    {
      type: 'example',
      title: 'Obligations légales selon la taille de l\'association',
      content: 'Les obligations varient selon votre taille et vos financements :',
      items: [
        'Budget < 153 000 € de subventions : pas de commissaire aux comptes obligatoire',
        'Budget > 153 000 € de subventions publiques : commissaire aux comptes obligatoire',
        'Associations reconnues d\'utilité publique : obligations comptables renforcées',
        'Toutes associations : comptes à présenter en AG + dépôt éventuel en préfecture',
      ],
    },
    {
      type: 'midcta',
      title: 'Trésorier bénévole sans formation financière ? Trezoone simplifie chaque étape de votre mission',
      content: 'Interface claire, rapports automatiques pour l\'AG, suivi des subventions et alertes intégrées — conçu pour les trésoriers associatifs.',
    },
    {
      type: 'checklist',
      title: 'Checklist trésorier association — tâches récurrentes',
      items: [
        'Mensuel : rapprochement bancaire (relevé vs comptabilité)',
        'Mensuel : mise à jour du plan de trésorerie avec les données réelles',
        'Trimestriel : suivi des subventions en cours et relances si nécessaire',
        'Semestriel : présentation de la situation financière au bureau',
        'Annuel : clôture des comptes, rapport financier pour l\'AG',
        'En continu : validation des dépenses selon le budget voté',
      ],
    },
    {
      type: 'solution',
      title: 'Trezoone simplifie la vie du trésorier associatif',
      content: 'Conçu pour les trésoriers bénévoles qui n\'ont pas forcément de formation financière.',
      items: [
        'Interface simple, pas de jargon technique',
        'Import des relevés bancaires en un clic',
        'Suivi des subventions avec alertes en cas de retard',
        'Rapport financier généré automatiquement pour l\'AG',
        'Accès partagé pour le président et les membres du bureau',
        'Données sauvegardées en sécurité, accessibles partout',
      ],
    },
    {
      type: 'cluster',
      title: 'Tout pour gérer la trésorerie de votre association',
      links: [
        { label: 'Logiciel trésorerie association', href: '/logiciel-tresorerie-association' },
        { label: 'Excel trésorerie association', href: '/excel-tresorerie-association' },
        { label: 'Subvention en retard', href: '/subvention-en-retard-tresorerie' },
        { label: 'Reporting financier association', href: '/reporting-financier-association' },
        { label: 'Simulateur trésorerie association', href: '/simulateur-tresorerie-association' },
        { label: 'Simulation trésorerie association', href: '/simulation-tresorerie-association' },
        { label: 'Plan de trésorerie', href: '/plan-tresorerie' },
        { label: 'Alerte trésorerie', href: '/alerte-tresorerie' },
      ],
    },
    {
      type: 'cta',
      title: 'Gérez la trésorerie de votre association sans stress',
      content: 'Trezoone accompagne les trésoriers associatifs. Essai gratuit 14 jours.',
    },
  ],
  relatedLinks: [
    { label: 'Logiciel trésorerie association', href: '/logiciel-tresorerie-association' },
    { label: 'Excel trésorerie association', href: '/excel-tresorerie-association' },
    { label: 'Subvention en retard', href: '/subvention-en-retard-tresorerie' },
    { label: 'Reporting financier association', href: '/reporting-financier-association' },
    { label: 'Simulateur trésorerie association', href: '/simulateur-tresorerie-association' },
    { label: 'Simulation trésorerie association', href: '/simulation-tresorerie-association' },
    { label: 'Plan de trésorerie', href: '/plan-tresorerie' },
    { label: 'Alerte trésorerie', href: '/alerte-tresorerie' },
  ],
};

interface Props { onNavigate?: (p: string) => void; onSignIn?: () => void; onSignUp?: () => void; }
export default function TresorerieAssociationLoi1901Page({ onNavigate, onSignIn, onSignUp }: Props) {
  return <SeoLandingLayout data={data} onNavigate={onNavigate} onSignIn={onSignIn} onSignUp={onSignUp} />;
}
